import React from "react";

import EntryComponent from "../../components/entry";
import { Navigate } from "react-router-dom";

interface EntryContainerInterface {}

const EntryContainer: React.FC<EntryContainerInterface> = () => {
  let token = localStorage.getItem("alrounderToken");
  const isAuthenticated = token ? true : false;
  if (isAuthenticated) {
    let url = "/processing";
    return <Navigate to={url} replace />;
  } else {
    let url = "/payment-info";
    return <Navigate to={url} replace />;
  }
};

export default EntryContainer;
